"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const switch_1 = require("components/cosmos/switch");
const SwitchContainer = ({ id, title, isChecked, children, className, 'data-test': dataTest, onChange }) => {
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)('_border _border-gray-200 _rounded-lg', className), children: [(0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)('_p-4', {
                    '_border-bottom _border-gray-200': isChecked
                }), children: (0, jsx_runtime_1.jsx)(switch_1.Switch, { id: id, className: "_mb-0", isChecked: isChecked, onChange: onChange, "data-test": dataTest, children: title }) }), children && (0, jsx_runtime_1.jsx)("div", { className: "_p-4", children: children })] }));
};
exports.default = SwitchContainer;
